import _ from 'lodash';
import React from 'react';
import { MdSave, MdDelete } from 'react-icons/md';
import Crud from '~/components/crud';
import confirm from '~/components/confirm';
import { formats } from '~/helper';
import { BlacklistForm, BlacklistSchema } from '~/views/blacklists/form';
import { Container } from '~/views/blacklists/styles';
import useBlacklists from '~/view-data/use-blacklists';

const columns = [
  {
    name: 'Nome',
    selector: 'name',
  },
  {
    name: 'CPF/Número de Registro',
    selector: 'identify',
    format: (row) => formats.cpf(_.get(row, 'identify')) || _.get(row, 'identify') || ''
  },
  {
    name: 'Cadastrado em',
    selector: 'createdAt',
    hide: 'md',
    width: '140px',
    format: (row) => formats.dateTimeZone(_.get(row, 'createdAt'), 'dd/MM/yyyy HH:mm')
  },
];

function Blacklists({ acls }) {
  const canWrite = acls.includes('W');
  const { state, actions } = useBlacklists();

  const handleRemove = async (data, action) => {
    const result = await confirm.show({
      title: 'Atenção',
      text: `Deseja realmente remover essa blacklist?`,
    });

    if (result) {
      actions.remove(data, action);
    }
  };

  const actionsList = [
      {
        label: 'Salvar',
        icon: MdSave,
        isSubmit: true,
        isDisabled: ({ isValid }) => !isValid || !canWrite,
        action: actions.createOrUpdate,
      }
    ];

  if (_.get(state, 'model.id')) {
    actionsList.push({
        label: 'Remover',
        icon: MdDelete,
        isDisabled: ({ isValid }) => !canWrite,
        action: handleRemove,
      });
  }

  return (
    <Container>
      <Crud
        columns={columns}
        emptyText='Nenhuma blacklist encontrada'
        data={state.data}
        hideAdd={!canWrite}
        tableLoading={state.loading}
        formLoading={state.formLoading}
        formTitle={(data) => (_.get(data, 'id')) ? `Blacklist #${data.id}` : `Nova blacklist`}
        onChangePage={actions.pageChange}
        onRowClicked={actions.load}
        formOptions={{
          validationSchema: BlacklistSchema,
          initialValues: state.model,
          initialTouched: { identify: true },
        }}
        renderForm={(args) => <BlacklistForm {...args} previewMode={!canWrite} />}
        actions={actionsList}
      />
    </Container>
  );
}

export default Blacklists;
